import GridItemMemo from './GridItem';

export default GridItemMemo;
